module.exports = __webpack_public_path__ + "img/carWashCode_03.a3e403f2.jpg";